// import '/assets/styles/partials/eventbox/productbox.scss';
import { useMemo } from 'react';
import classNames from 'classnames';
import types from '/views/partials/eventbox/types';

export const Eventbox = ({ type = 'regular', className: classNameProp, product, ...props }) => {
	const BoxElem = types[type] ?? types['regular'];

	const className = useMemo(() => {
		return classNames('eventbox', classNameProp);
	}, [classNameProp]);

	return <BoxElem {...props} product={product} className={className} />;
};

export default Eventbox;
